import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "Working with Richmond Holdings Group has been a game-changer. Their insights transformed our operations and meaningfully enhanced service delivery to the community.",
    name: "Stacy P.",
    role: "Procurement Officer",
  },
  {
    quote:
      "Exceptional consulting — knowledgeable, professional, and fully committed to outstanding results. A genuine pleasure collaborating with their team.",
    name: "Gloria",
    role: "Glo-Solutions",
  },
  {
    quote:
      "They exceeded our expectations with innovative solutions and deep government consulting expertise. Valuable support at every stage of our project.",
    name: "Michael Johnson",
    role: "Government Project Lead",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-40 bg-[#070d1a] border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <p
            className="text-[11px] font-bold uppercase tracking-[0.32em] text-[#d4af37] mb-5 reveal"
            data-testid="testimonials-overline"
          >
            <span className="gold-rule" /> The Word
          </p>
          <h2
            className="font-serif-editorial text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-white reveal"
            data-testid="testimonials-headline"
          >
            What partners <span className="italic text-[#d4af37]">say</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="relative bg-white/[0.03] backdrop-blur-xl border border-white/10 hover:border-[#d4af37]/40 p-8 md:p-10 transition-colors duration-500 reveal"
            >
              <Quote
                size={30}
                strokeWidth={1}
                className="text-[#d4af37]/80 mb-5"
              />
              <blockquote className="font-serif-editorial italic text-lg md:text-xl leading-[1.5] text-slate-200">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <p className="text-white text-sm">{t.name}</p>
                <p className="text-[10px] uppercase tracking-[0.26em] text-slate-500 mt-1">
                  {t.role}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
